/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_DeadlineInputs */

const en_task_settings_deadline = /** @type {(inputs: Task_Settings_DeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deadline in business days`)
};

const pt_br2_task_settings_deadline = /** @type {(inputs: Task_Settings_DeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazo em dias úteis`)
};

/**
* | output |
* | --- |
* | "Deadline in business days" |
*
* @param {Task_Settings_DeadlineInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_deadline = /** @type {((inputs?: Task_Settings_DeadlineInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_DeadlineInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_deadline(inputs)
	return pt_br2_task_settings_deadline(inputs)
});